export default {
    title: null,
    text: null,
    image: null,
    mobileImage: null,
    gradient: null,
    footerTitle: null,
    footerImage: null,
    footerText: null
}
